import { render, staticRenderFns } from "./create-agent.vue?vue&type=template&id=cf6cf7fa"
import script from "./create-agent.vue?vue&type=script&lang=js"
export * from "./create-agent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports